import type { RevisaoGanttProps } from "./types-revisao-gantt";
import { useRevisaoGantt } from "./use-revisao-gantt";
import { RevisaoGanttView } from "./view-revisao-gantt";

export function RevisaoGantt(props: RevisaoGanttProps) {
  const vm = useRevisaoGantt(props);

  return <RevisaoGanttView {...vm} />;
}

export type * from "./types-revisao-gantt";
